import styled, { css } from 'styled-components'

import { Separator, Skeleton } from '@root/shared/ui-kit'

export const PremiumCurrencyDetailsSkeleton: React.FC = () => {
  return (
    <Root>
      <Group>
        <ImagesRoot>
          <CurrencyEdit>
            <Skeleton height="100%" width="100%" />
          </CurrencyEdit>
        </ImagesRoot>
        <EmojiRoot>
          <Skeleton height={24} width={24} variant="circular" />
          <Skeleton.Line width={'8ch'} />
          <EditIconSlot>
            <Skeleton height={19} width={19} />
          </EditIconSlot>
        </EmojiRoot>
        <Separator fullWidth />
        <HeadingRoot>
          <Skeleton height={16} width={120} />
          <Skeleton height={12} width={40} />
          <Skeleton height={12} width={160} />
        </HeadingRoot>
      </Group>

      <AddressShell>
        <Skeleton height={12} width="70%" />
        <Separator
          vertical
          css={css`
            height: 30px;
          `}
        />
        <Skeleton height={16} width={16} />
      </AddressShell>

      <LinksSection>
        <Separator fullWidth />
        <LinksForm>
          <LinksGroup>
            <InputSkeleton height={42} />
            <InputSkeleton height={42} />
            <InputSkeleton height={42} />
          </LinksGroup>
          <SaveButton height={40} />
        </LinksForm>
        <Separator fullWidth />
      </LinksSection>

      <PremiumRoot>
        <PremiumHeader>
          <Skeleton height={14} width={140} />
          <Skeleton height={14} width={70} />
        </PremiumHeader>
        <PremiumFooter>
          <BoosterPill height={24} width={80} />
        </PremiumFooter>
      </PremiumRoot>

      <MetricsTableRoot>
        <PriceRow>
          <PriceCell>
            <Skeleton height={12} width={48} />
            <Skeleton height={20} width={64} />
          </PriceCell>
          <PriceCell>
            <Skeleton height={12} width={48} />
            <Skeleton height={20} width={64} />
          </PriceCell>
        </PriceRow>
        <VolumeRow>
          <VolumeCell>
            <Skeleton height={12} width={56} />
            <Skeleton height={20} width={48} />
          </VolumeCell>
          <Separator vertical />
          <VolumeCell>
            <Skeleton height={12} width={40} />
            <Skeleton height={20} width={48} />
          </VolumeCell>
          <Separator vertical />
          <VolumeCell>
            <Skeleton height={12} width={64} />
            <Skeleton height={20} width={48} />
          </VolumeCell>
        </VolumeRow>
      </MetricsTableRoot>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  gap: 16px;
  grid-auto-rows: auto;
`

const Group = styled.div`
  display: grid;
  align-items: center;
  justify-items: center;
  text-transform: uppercase;
  gap: 16px;
`

const ImagesRoot = styled.div`
  display: grid;
  position: relative;
  align-content: end;
  width: 100%;
  height: 138px;
`

const CurrencyEdit = styled.div`
  position: relative;
  justify-self: center;
  width: 100px;
  height: 100px;
  border-radius: 10px;
  overflow: hidden;
`

const EmojiRoot = styled.div`
  background: var(--appearance-1);
  display: grid;
  grid-template-columns: auto auto auto;
  align-items: center;
  gap: 6px;
  border-radius: 64px;
  padding: 2px;
`

const EditIconSlot = styled.div`
  display: grid;
  margin: 0 8px;
`

const HeadingRoot = styled.div`
  display: grid;
  align-items: center;
  justify-items: center;
  gap: 4px;
`

const AddressShell = styled.div`
  display: grid;
  grid-template-columns: 1fr auto auto;
  align-content: center;
  align-items: center;
  gap: 12px;
  border: 1px solid var(--background-3);
  background: var(--background-1);
  border-radius: 12px;
  height: 40px;
  padding: 0 16px;
  width: auto;
`

const LinksSection = styled.div`
  display: grid;
  gap: 12px;
`

const LinksForm = styled.div`
  display: grid;
  gap: 12px;
`

const LinksGroup = styled.div`
  display: grid;
  gap: 6px;
`

const InputSkeleton = styled(Skeleton)`
  border-radius: 10px;
`

const SaveButton = styled(Skeleton)`
  border-radius: 8px;
`

const PremiumRoot = styled.div`
  display: grid;
  gap: 10px;
  margin: auto;
  align-items: center;
  justify-content: center;
  text-align: center;
`

const PremiumHeader = styled.div`
  display: flex;
  column-gap: 8px;
  align-items: baseline;
  justify-content: center;
  flex-wrap: wrap;
`

const PremiumFooter = styled.div`
  display: grid;
  justify-content: center;
`

const BoosterPill = styled(Skeleton)`
  border-radius: 50px;
`

const MetricsTableRoot = styled.div`
  display: grid;
  flex-shrink: 0;
  border-radius: 12px;
  border: 1px solid var(--backgroundA-2, rgba(255, 255, 255, 0.04));
  background: var(--appearanceA-7);
  gap: 6px;
  padding: 6px;
`

const PriceRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3px;
`

const VolumeRow = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr auto 1fr;
`

const PriceCell = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px;
  background: var(--background-1);
  flex-shrink: 0;
  gap: 2px;
  border-radius: 8px;
`

const VolumeCell = styled(PriceCell)`
  background: transparent;
  gap: 0;
`
